import { render, staticRenderFns } from "./ScreenPrice.vue?vue&type=template&id=44ca4a14&scoped=true&lang=pug"
import script from "./ScreenPrice.vue?vue&type=script&lang=ts"
export * from "./ScreenPrice.vue?vue&type=script&lang=ts"
import style0 from "./ScreenPrice.vue?vue&type=style&index=0&id=44ca4a14&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ca4a14",
  null
  
)

export default component.exports